import React from 'react'
import { NavLink } from 'react-router-dom'
import { Card, Label, Menu } from 'semantic-ui-react'

import CancelSubscriptionItem from 'components/superuser/billing/CancelSubscriptionItem'
import PauseSubscriptionItem from 'components/superuser/billing/PauseSubscriptionItem'
import ResumeSubscriptionItem from 'components/superuser/billing/ResumeSubscriptionItem'

const STATUS_COLORS = { active: 'green', paused: 'yellow', cancelled: 'grey' }

export default function BillingSubscriptionsListItem ({ billingSubscription }) {
  const sub = billingSubscription
  return (
    <Card>
      <Card.Content as={NavLink} to={Routes.superuser_billing_subscription_path({ id: sub.id })}>
        <Card.Header>{sub.billableName || `${sub.billableType} #${sub.billableId}`}</Card.Header>
        <Card.Meta>{sub.planName || `Plan #${sub.planId}`} · started {sub.startsOn}</Card.Meta>
      </Card.Content>
      <Card.Content extra>
        <Label color={STATUS_COLORS[sub.status] || 'grey'}>{sub.status}</Label>
      </Card.Content>
      <Card.Content extra style={{ padding: 0 }}>
        <Menu compact icon borderless secondary size="large">
          <PauseSubscriptionItem billingSubscription={sub}/>
          <ResumeSubscriptionItem billingSubscription={sub}/>
          <CancelSubscriptionItem billingSubscription={sub}/>
        </Menu>
      </Card.Content>
    </Card>
  )
}
